const Workflow = ({ data }) => {
  if (!data) return null;

  const tooltips = [
    "This is your starting gate! Upload your documents and the system reads them, figures out what you're dealing with, and gives you an initial 'should we proceed?' recommendation. Quick and painless!",
    "The speed round! Each area (Legal, Budget, HR, Tech, Security) gets a rapid check for any major red flags. If something's seriously wrong, you'll know fast - before investing more time and resources.",
    "Time to dig deeper! For the tricky or risky areas, this expands the checklist and assigns specific people to investigate. Everything gets an owner, a deadline, and a plan to fix it.",
    "The finish line prep! This creates your game plan for actually making it all work after you win. It maps out who does what, when things need to happen, and tracks progress on fixing any issues."
  ];

  return (
    <section className="py-16 px-6" data-testid="workflow-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold mb-4">{data.title}</h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.steps.map((step, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 border-2 border-dashed border-gray-300 hover:border-purple-400 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
              data-testid={`workflow-step-${index}`}
              data-robot-tooltip={tooltips[index]}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/10 to-blue-600/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <div className="text-xs font-semibold uppercase tracking-widest text-gray-600 mb-2">
                  {step.label}
                </div>
                <h3 className="text-lg font-semibold mb-4 text-gray-900">
                  {step.title}
                </h3>
                <ul className="space-y-2 text-sm text-gray-600">
                  {step.items.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-purple-600 mr-2 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Workflow;
